import { clearQuotes } from '@marmalade/multi-quote/lib/quick-quote/actions';
import { getFormId } from '../proceed-modal/modal';
import reset from '../reset';
import { formId } from './form';

export default reset(clearQuotes, formId, getFormId('multi'));
